import Vue from 'vue';
import User from '@/libs/user';

Vue.directive('int', {
  update(el) {
    const input = el.nodeName === 'INPUT' ? el : el.querySelector('input');
    input.value = input.value !== undefined ? input.value.replace(/\D/g, '') : '';
  },
});


// 角色权限控制--0 - 管理员；1 - 操作员；2 - 财务
const permissionMap = {
  '-1': ['create-insurance-order', 'create-visa-order'], // 未登录
  1: ['create-insurance-order', 'create-visa-order'], // 操作员
  2: [], // 财务
};
const hideNode = (permission) => {
  try {
    const role = User.isLogin() ? User.role_id : -1;
    if (role === 0) return false; // 是管理员不做操作
    // 非管理员，进行角色权限判定
    if (!permission) return false;
    return !permissionMap[role].includes(permission);
  } catch (error) {
    // 报错了直接隐藏
    return true;
  }
};

Vue.directive('display', {
  inserted(el, binding) {
    if (hideNode(binding.arg)) {
      el.style.display = 'none';
    }
  },
});

// fixed元素跟随滚动条
Vue.directive('fixed-scroll', {
  bind(el) {
    const initTop = window.scrollY;
    const updatePosition = () => {
      const scrollTop = window.scrollY;
      const diffTop = scrollTop - initTop;

      el.style.transform = `translateY(${-diffTop}px)`;
    };
    
    window.addEventListener('scroll', updatePosition);
    // 组件卸载时移除事件监听
    el._onScroll = updatePosition;
  },
  unbind(el) {
    window.removeEventListener('scroll', el._onScroll);
  },
});


// 下载资料按钮禁用
Vue.directive('download-disabled', {
  inserted(el, binding) {
    // 产品要求未登录能点击显示登录,登录没有权限隐藏
    // if (!User.isLogin()) {
    //   el.disabled = true;
    // } else {
    //   const disabled = User.disabled_permission_list && User.disabled_permission_list.includes(binding.arg);
    //   if (disabled) {
    //     el.style.display = 'none';
    //   }
    // }
    const disabled = User.disabled_permission_list && User.disabled_permission_list.includes(binding.arg);
    if (disabled) {
      el.style.display = 'none';
    }
  },
  update(el, binding) {
    // if (!User.isLogin()) {
    //   el.disabled = true;
    // } else {
    //   const disabled = User.disabled_permission_list && User.disabled_permission_list.includes(binding.arg);
    //   if (disabled) {
    //     el.style.display = 'none';
    //   }
    // }
    const disabled = User.disabled_permission_list && User.disabled_permission_list.includes(binding.arg);
    if (disabled) {
      el.style.display = 'none';
    }
  },
});


export default null;



// WEBPACK FOOTER //
// ./src/libs/directives.js